import { inject, NgModule } from '@angular/core';
import {
  ApolloClientOptions,
  ApolloLink,
  concat,
  defaultDataIdFromObject,
  InMemoryCache,
  StoreObject
} from '@apollo/client/core';
import {
  NamedOptions,
  provideApollo,
  provideNamedApollo
} from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';

import { CookieService } from '@app/shared/services/cookie.service';
import { environment } from '@env/environment';

import { TokenDataEnum } from './core/auth/auth.model';

const withdrawUri =
  environment.api.brasilprev.url + '/withdraw-bff-portal-service/graphql';
const cookie = new CookieService();

const authMiddleware = new ApolloLink((operation, forward) => {
  operation.setContext(() => ({
    headers: {
      Authorization: `OAUTH2 ${cookie.get(TokenDataEnum.AuthToken)}`,
      canaloperacao: '5',
      cpf: sessionStorage.getItem('profile: cpf') || ''
    }
  }));

  return forward(operation);
});

const authIncomeTax = new ApolloLink((operation, forward) => {
  operation.setContext(() => ({
    headers: {
      Authorization: `Bearer ${cookie.get(TokenDataEnum.AuthToken) || ''}`
    }
  }));

  return forward(operation);
});

function createDefaultApollo(httpLink: HttpLink): ApolloClientOptions<unknown> {
  return {
    link: httpLink.create({
      uri: environment.api.brasilprev.url
    }),
    cache: new InMemoryCache()
  };
}

function createCustomID(object: Readonly<StoreObject>) {
  const customID = {
    Plan: `Plan:${object.registration}`,
    Simulate: `Simulate:${object.registration}`,
    default: defaultDataIdFromObject(object)
  };

  return customID[object.__typename] || customID.default;
}

function createCustomApollo(httpLink: HttpLink): NamedOptions {
  return {
    withdraw: {
      name: 'withdraw',
      link: concat(authMiddleware, httpLink.create({ uri: withdrawUri })),
      cache: new InMemoryCache({
        dataIdFromObject(responseObject) {
          return createCustomID(responseObject);
        }
      })
    },
    transactionPassword: {
      name: 'transactionPassword',
      link: concat(authIncomeTax, httpLink.create({ uri: withdrawUri })),
      cache: new InMemoryCache()
    }
  };
}

@NgModule({
  providers: [
    provideApollo(() => {
      const httpLink = inject(HttpLink);

      return createDefaultApollo(httpLink);
    }),
    provideNamedApollo(() => {
      const httpLink = inject(HttpLink);
      return createCustomApollo(httpLink);
    })
  ]
})
export class GraphQLModule {}
